import { useMutation } from '@tanstack/react-query';
import { markContentAsDone } from '../../../core/queries/course';

function useMarkContentAsDone() {
  const { data, isError, error, isSuccess, isPending, mutate } = useMutation({
    mutationKey: ['mark-content-as-done'],
    mutationFn: (data: any) =>
      markContentAsDone(data.courseId, data.programId, data.contentId),
    retry: false
  });

  return {
    data,
    isError,
    isLoading: isPending,
    error,
    isSuccess,
    mutate,
  };
}

export { useMarkContentAsDone };
